import { apiClient, apiClientAuth, apiClientOther  } from "./client";
import { getDeviceId } from "../utils/deviceId";



export const getUser = async (mobno) => {
  const token = localStorage.getItem("token") || "";
  const response = await apiClient.get("GETUSER", {
    params: { mobno },
    headers: {
      mobno: mobno,
      token: token
    }
  });
  return response.data;
};

export const checkUserStatus = async () => {
  const token = localStorage.getItem("token") || "";
  const mobno = localStorage.getItem("loginname") || "";
  const response = await apiClient.get("CHKSTATUS", {
    params: { mobno },
    headers: { token: token },
  });
  return response.data;
};

export const updateUser = async (data) => {
  const token = localStorage.getItem("token") || "";
  const loginname = localStorage.getItem("loginname") || "";
  // Data payload contains username, email, password, etc as per curl request
  const response = await apiClient.post("UPDUSER", data, {
    params: { mobno: loginname },
    headers: {
      loginname: loginname,
      token: token,
      "Content-Type": "application/json"
    }
  });
  return response.data;
};



export const registerUser = async (data) => {
  const deviceId = getDeviceId();
  const payload = { ...data, device_id: deviceId };
  const response = await apiClientOther.post("/register", payload);
  return response.data;
};

export const login = async (data) => {
  const deviceId = getDeviceId();
  const res = await apiClientAuth.post("", {
    grant_type: "code",
    method: "SMS",
    device_id: deviceId,
  }, {
    headers: {
      loginname: data.mobno,
    },
  });
  if (res.data && res.data.Status === "0") {
    const err = new Error(res.data.message || "Failed to login");
    err.response = { data: res.data };
    throw err;
  }
  return res.data;
};


export const verifyOtp = async (data) => {
  const deviceId = getDeviceId();
  const response = await apiClientAuth.post("", {
    grant_type: "token",
    OTP: data.otp,
    device_id: deviceId,
  }, {
    headers: {
      loginname: data.mobno,
    },
  });
  if (response.data && response.data.Status === "0") {
    const err = new Error(response.data.message || "Failed to verify OTP");
    err.response = { data: response.data };
    throw err;
  }
  return response.data;
};

export const getAllUsers = async () => {
  const token = localStorage.getItem("token") || "";
  const loginname = localStorage.getItem("loginname") || "";
  const response = await apiClient.get("getalluser", {
    headers: {
      loginname: loginname,
      token: token
    }
  });
  return response.data;
};

